import React from "react";
import { useForm } from "react-hook-form";
import HCaptcha from '@hcaptcha/react-hcaptcha';

interface ContactFormProps {
  form: {
    access_key: string;
    form_name: string;
    form_mobile: string;
    form_email: string;
    message: string;
    "h-captcha-response": string;
  };
  alert: {
    type: string;
    message: string;
  };
  handleChange: (e: any) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const ContactForm: React.FC<ContactFormProps> = ({form,alert,handleChange,handleSubmit}) =>{
  const { setValue } = useForm<{
    form_name: string;
    form_mobile: string;
    form_email: string;
    message: string;
    "h-captcha-response": string;
  }>();

  const onHCaptchaChange = (token: string) => {
  handleChange({
    target: {
      name: "h-captcha-response",
      value: token
    }
  });
  };


  return (
    <form className="footer-contact-form" onSubmit={handleSubmit} autoComplete="off">
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-2 mb-2 w-100`} role="alert">
          {alert.message}
        </div>
      )}

      <input
        type="text"
        name="form_name"
        className="form-control mb-2"
        placeholder="Your Name"
        value={form.form_name}
        onChange={handleChange}
      />

      <input
        type="text"
        name="form_mobile"
        className="form-control mb-2"
        placeholder="Mobile Number"
        value={form.form_mobile}
        onChange={handleChange}
      />

      <input
        type="email"
        name="form_email"
        className="form-control mb-2"
        placeholder="Your Email"
        value={form.form_email}
        onChange={handleChange}
      />

      <textarea
        name="message"
        className="form-control mb-2"
        placeholder="Write your query"
        rows={3}
        value={form.message}
        onChange={handleChange}
      />
      <HCaptcha
        sitekey="50b2fe65-b00b-4b9e-ad62-3ba471098be2"
        onVerify={onHCaptchaChange}
      />
      <button type="submit" className="btn-knowmore" disabled={!form["h-captcha-response"]}>Send Now</button>
    </form>
  );
}

export default ContactForm;

